import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  padding: ${({ theme }) => `${theme.spacing['5']}px ${theme.spacing['4']}px`};
  gap: ${({ theme }) => theme.spacing['5']}px;
`;

export const ContainerBeneficios = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[3]}px;
`;

export const ContainerProviders = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing['4']}px;
`;

export const ContainerDetalhesProviders = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing['2']}px;
`;

export const ContainerEscolhaProviders = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing['2']}px;
`;

export const ImageContainer = styled.div<{ $alturaImagem: number }>`
  display: flex;
  flex: 1;
  position: relative;
  height: ${({ $alturaImagem }) => $alturaImagem}px;
`;

export const ImageEscolhaProvider = styled.div<{ $alturaImagem: number }>`
  display: flex;
  position: relative;

  height: ${({ $alturaImagem }) => $alturaImagem}px;
  width: ${({ $alturaImagem }) => $alturaImagem}px;
`;

export const BotaoEscolherProvider = styled.button`
  background: none;
  outline: none;
`;

export const ContainerPrecoPlano = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: ${({ theme }) => theme.spacing['2']}px;
`;

export const ContainerCarrinho = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;

  justify-content: space-between;
`;

export const ContainerPrecos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  gap: ${({ theme }) => theme.spacing['1']}px;
`;

export const ContainerDetalhesAccordion = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${({ theme }) => theme.spacing['5']}px;
`;
